<template>

    <ul class="row expanded small-up-2 medium-up-3 large-up-4">
        <li v-for="(countries, index) in countriesList" :value="countries.name" class="column column-block">
          <a target="_blank" :href="countries.wwfurl + '/?referer=wwfau'">
            {{countries.name}}
          </a>
          </li>
    </ul>


</template>

<script>
  import { getCountriesListForMenu } from "../helpers";
  
  export default {
  name: 'wwf-country-list',
  data: function () {
          return {
          countriesList: getCountriesListForMenu()
          }
      }
  }

</script>
<style>

</style>


// WEBPACK FOOTER //
// WwfCountryList.vue?ff152fbc